import { render, staticRenderFns } from "./MenuItem.vue?vue&type=template&id=318d8442&scoped=true"
import script from "./MenuItem.vue?vue&type=script&lang=js"
export * from "./MenuItem.vue?vue&type=script&lang=js"
import style0 from "./MenuItem.vue?vue&type=style&index=0&id=318d8442&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318d8442",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Adipose Gateway - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('318d8442')) {
      api.createRecord('318d8442', component.options)
    } else {
      api.reload('318d8442', component.options)
    }
    module.hot.accept("./MenuItem.vue?vue&type=template&id=318d8442&scoped=true", function () {
      api.rerender('318d8442', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MenuItem.vue"
export default component.exports